import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { MatRadioChange } from '@angular/material/radio';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { Router } from '@angular/router';

export interface State {
  name: string;
  fax: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-bind-field-ai',
  templateUrl: './bind-field-ai.component.html',
  styleUrls: ['./bind-field-ai.component.scss']
})
export class BindFieldAIComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  responseHolder: any;
  LoggedInEmailId: string = "";
  currentUser: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  ExtractDocument:any=[]=[];
  Feildproperty:any=[] = []; 
  FeildpropertyAI:any=[] = []; 

  @Input() folderID: number = 0;
  
  @Output() closeBindEmit = new EventEmitter<boolean>();

  clickEventsubscriptionCoreAI: Subscription;
  
  feildsCtrl: FormControl;
  feildsCtrlAI: FormControl;

  filteredFeilds: any=[]=[];
  filteredFeildsAI: any=[]=[];

  ShowDeleteButton:boolean=false;

  CreateField:boolean=true;
  Finish:boolean=true;
  fieldListFiltered:any=[];
  selectedFileArray: any = [] = [];

  fieldListFilteredAI:any=[];

  CoreShowName: string = "";
  ContactShowName: string = "";
  CompanyShowName: string = "";
  @Input() mainModuleName: string;
  menuModulesList: any = [] = [];
  stateCtrlValue: string;
  objectList: any = [];
  toggleChangeCore = false;

  @Input() modulename: string;
  @Input() mainModulename: string;
  @Input() transactionID: number;
  @Input() typeId: number=0; 
  @Input() name: string=""; 
  @Input() email: string=""; 
  @Input() imageUrl: string=""; 
  @Input() status: string=""; 

  formDialog: FormGroup;

  constructor(private _dataSharingService: DataSharingService,
    private loaderService: LoaderService,private encryptionAlgo: EncryptionService, 
    private reusableClass: ReusableClasses,private statusConst: StatusConstant,
    private settingsService: SettingService,private dialog: MatDialog,
    private toastr: ToastrService,private coreService: CoreService,
    private formBuilder: FormBuilder,private router: Router,) {
      const encryptedtoken = sessionStorage.getItem('userToken');
      this.databaseId = sessionStorage.getItem('databaseId')?? '';
       this.organizationId = sessionStorage.getItem('organizationID')?? '';
      this.LoggedInEmailId = sessionStorage.getItem('email');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
        this.OfficeIDList.push(oe.officeID)
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });

      this.feildsCtrl = new FormControl();
      this.filteredFeilds = this.feildsCtrl.valueChanges.pipe(startWith(''),
      map((feilds) =>
      feilds ? this.filterFeilds(feilds) : this.Feildproperty.slice()));

      this.stateCtrl.setValue(this.stateCtrlValue);
      this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''), map((state) => (state ? this._filterStates(state) : this.states.slice())));

     // this.feildsCtrlAI = new FormControl();
      // this.stateCtrl.setValue(this.stateCtrlValue);
      // this.filteredStates = this.stateCtrl.valueChanges.pipe(
      // startWith(''), map((state) => (state ? this._filterStates(state) : this.states.slice())));

      }

      ChangeCore(){
        this.toggleChangeCore = true;
        this.ShowAttchedToCore=true;
        this.CreateField=true;
        this.Finish=true;

      //   var checkw=[];
      //   checkw = this.ExtractDocument.filter(x=>x.colorCode=="#cc570e");
      //   if(checkw.length>0){
      //   this.CreateField=false;
      //   this.Finish=true;
      //  }else{
      //   this.CreateField=true;
      //   this.Finish=false;
      //  }
      }

  filterFeilds(name: string) {
    let arr = this.Feildproperty.filter((feilds) => feilds.fieldName.toLowerCase().indexOf(name.toLowerCase()) === 0);
    if(arr.length==0){
     this.CreateField=false;
     this.Finish=true;
    }
    return arr;
  }

  // filterFeildsAI(name: string) {
  //   let arr = this.FeildpropertyAI.filter((feilds) => feilds.fieldName.toLowerCase().indexOf(name.toLowerCase()) === 0);

  //   if(arr.length==0){
  //   //  this.CreateField=false;
  //   //  this.Finish=true;
  //   }
  //   return arr;
  // }

  states = this.objectList;

  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();
    return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }
  
  ngOnDestroy() {
    this.ExtractDocument=[];
    this.selectedFileArray=[];
    this.ShowDeleteButton=false;
    this.toggleChangeCore=false;
    this.clickEventsubscriptionCoreAI.unsubscribe();
  }

  ngOnInit(): void {
    // let group = {};
    // this.formDialog = new FormGroup(group);
    // this.formDialog.addControl('fieldName',this.formBuilder.control(''));
   // this.mainModuleName;
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var SelectedCore = [];
    var SelectedContact = [];
    var SelectedCompany = [];

    SelectedCore = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
    }

    SelectedContact = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Contact');
    if (SelectedContact.length > 0) {
      this.ContactShowName = SelectedContact[0].orgModuleName;
    }

    SelectedCompany = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Company');
    if (SelectedCompany.length > 0) {
      this.CompanyShowName = SelectedCompany[0].orgModuleName;
    }
    this.clickEventsubscriptionCoreAI = this._dataSharingService.getSelectedDocForBindAI().subscribe((result:any) => {
      if(result) {           
        if(result.mainModulename=="File Manager"){
          this.folderID=0;
          this.transactionID=0;
          this.modulename=result.modulename;
          this.mainModulename=result.mainModulename;
          this.typeId=result.typeId;
          this.name="";
          this.email="";
          this.imageUrl="";
          this.status="";
          var SelectedCore = [];
          SelectedCore = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Core');
          if (SelectedCore.length > 0) {
           this.folderID = SelectedCore[0].folderID;
          }  
          this.ChangeCore();
          this.getFieldForImportExport(result);
        }else{
          this.toggleChangeCore=false;
          this.folderID=result.folderID;
          this.transactionID=result.transactionID;
          this.modulename=result.modulename;
          this.mainModulename=result.mainModulename;
          this.typeId=result.typeId;
          this.name=result.name;
          this.email=result.email;
          this.imageUrl=result.imageUrl;
          this.status=result.status;
          this.getFieldForImportExport(result);
        }     

       this.CreateField=true;
       this.Finish=true;
       this.fieldListFiltered=[];
       this.fieldListFilteredAI=[];
       this.ExtractDocument=[];
       this.selectedFileArray=[];
       this.ShowDeleteButton=false;      
      }     
    });
  }

  extractDocumentData(document:any){
    let ReqModel = {
      cccid: Number(this.transactionID),//Number(this.folderID),
      folderId: Number(this.folderID),
      typeID: 1, //1-Core, 2-Contact, 3-Company
      docUrl: document.azureblobPath,
      placehlderID: document.placeholderID,
      documentID: document.coreDocumentID,
      callFrom: 1,  //1-CCC / FileManager-2
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      databaseID: Number(this.databaseId),     
    };
    this.loaderService.showAILoader();
    this.settingsService.extractDocumentData(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response.data.keyValueData;
        this.ExtractDocument= this.responseHolder;
        if (this.ExtractDocument.length > 0) {
          this.ExtractDocument.map(e => {
            var check=[];
            var fieldName;
            var colorCode="";
             check = this.Feildproperty.filter(x=>x.fieldID == e.fieldID)
             if(check.length>0){
              fieldName=check[0].fieldName;
              colorCode = "#47e309";
             }else{
              fieldName="";
              colorCode = "";
             }
           // e.fieldID = 0;
            e.id = this.randomId();
            e.fieldName = fieldName;
            e.mapFields = null;
            e.colorCode = colorCode;
          });
        }
        this.loaderService.hideAILoader();
      } else {
        this.loaderService.hideAILoader();
      }
    });
  }

  extractDocumentDataFileManager(document:any){
    let ReqModel = {
      cccid: Number(this.transactionID),//Number(this.folderID),
      folderId: Number(this.folderID),
      typeID: 1, //1-Core, 2-Contact, 3-Company
      docUrl: document.azureblobPath,
      placehlderID: 0,//document.placeholderID,
      documentID: document.fileManagerItemID,
      callFrom: 2,  //1-CCC / FileManager-2
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      databaseID: Number(this.databaseId),     
    };
    this.loaderService.showAILoader();
    this.settingsService.extractDocumentDataFileManager(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response.data.keyValueData;
        this.ExtractDocument= this.responseHolder;
        if (this.ExtractDocument.length > 0) {
          this.ExtractDocument.map(e => {
            var check=[];
            var fieldName;
            var colorCode="";
             check = this.Feildproperty.filter(x=>x.fieldID == e.fieldID)
             if(check.length>0){
              fieldName=check[0].fieldName;
              colorCode = "#47e309";
             }else{
              fieldName="";
              colorCode = "";
             }
           // e.fieldID = 0;
            e.id = this.randomId();
            e.fieldName = fieldName;
            e.mapFields = null;
            e.colorCode = colorCode;
          });
        }
        this.loaderService.hideAILoader();
      } else {
        this.loaderService.hideAILoader();
      }
    });
  }

   randomId() {
    return Math.random();
  }

  closeAiDetail(closeDetail: boolean) {
    this.transactionID=0;
    this.feildsCtrl.reset();  
    this.fieldListFiltered=[];
    this.fieldListFilteredAI=[];
    this.ExtractDocument=[];
    this.selectedFileArray=[];
    this.ShowDeleteButton=false;
    this.CreateField=true;
    this.Finish=true;
    this.toggleChangeCore=false;
    this.checkedAttachCore=true;
    this.checkedAttachContact=false;
    this.checkedAttachCompany=false;

    this.attachedToSelectedCore=[];
    this.attachedToSelectedContact=[];
    this.attachedToSelectedCompany=[];

    this.closeBindEmit.emit(closeDetail);    
  }


  getFieldForImportExport(result) {
    var ReqModel = {
     searchKey: '',
     isSearch: false,
     isReturnSynonyms: true,
     userId: this.currentUser.UID,
     organizationID: Number(this.organizationId),     
     officeID: this.myOfficeID,
     folderId: Number(this.folderID),
     }
     this.loaderService.showAILoader();
     this.settingsService.getSynonyms(ReqModel).subscribe(response => {
     if(response != undefined) {
        this.responseHolder = response;
        this.loaderService.hideAILoader();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
         // this.synonymFieldsAI=this.responseHolder.data.synonymFields;
         this.Feildproperty=this.responseHolder.data.systemFields;
         if(this.mainModulename=="File Manager"){
          this.extractDocumentDataFileManager(result);
        }else{
          this.extractDocumentData(result);
        }  
         
        }else{
          if(this.mainModulename=="File Manager"){
            this.extractDocumentDataFileManager(result);
          }else{
            this.extractDocumentData(result);
          }
          this.Feildproperty =[]; 
          this.loaderService.hideAILoader();         
        }
      }else{     
     
       this.loaderService.hideAILoader();
      }
    });
  } 

  //  // GetFieldForApi for Dropdown // 
  //  getFieldForImportExport(result) {
  //     var ReqModel = {
  //       folderID: this.folderID,
  //       UserId: this.currentUser.UID,
  //       OrganizationID:  Number(this.organizationId),      
  //       officeID: this.myOfficeID,
  //      }
  //      this.settingsService.GetFieldForImportExport(ReqModel).subscribe(response => {
  //      if(response != undefined) {
  //         this.responseHolder = response;
  //         if (this.responseHolder.status == this.statusConst.statusSuccess) {
  //           this.Feildproperty = this.responseHolder.data;
  //           if(this.mainModulename=="File Manager"){
  //             this.extractDocumentDataFileManager(result);
  //           }else{
  //             this.extractDocumentData(result);
  //           }           
  //         }else{
  //           if(this.mainModulename=="File Manager"){
  //             this.extractDocumentDataFileManager(result);
  //           }else{
  //             this.extractDocumentData(result);
  //           }
  //           this.Feildproperty =[];          
  //         }
  //       }else{
  //         if(this.mainModulename=="File Manager"){
  //           this.extractDocumentDataFileManager(result);
  //         }else{
  //           this.extractDocumentData(result);
  //         }
  //         this.Feildproperty =[];          
  //       }
  //     });
  //  } 




   //Checkbox Change detecting function
   getCheckboxValues(event, document) {   
    this.ShowDeleteButton = true;
    if (event.checked) {
      let ReqModel = {
        selectedDocument: document,
      };
      this.selectedFileArray.push(ReqModel);     
    } else {
      let removeIndex = this.selectedFileArray.findIndex((itm) => itm.selectedDocument === document);
      if (removeIndex !== -1) this.selectedFileArray.splice(removeIndex, 1);    
    }
    if(this.selectedFileArray.length == 0) {     
     this.ShowDeleteButton = false;      
    }
   }

   deleteSelectedFields() {
    const message = `Are you sure you want to delete this fields?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);   
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {         
          for (let i = 0; i < this.selectedFileArray.length; i++) {
            const index: number = this.ExtractDocument.indexOf(this.selectedFileArray[i].selectedDocument);
             if (index !== -1) {
              this.ExtractDocument.splice(index, 1);
             } 
          }
          this.selectedFileArray=[];
          this.ShowDeleteButton=false;
          this.toastr.success('Fields deleted successfully.', '', {
            timeOut: 3000,
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }


  searchFields(val,items:any) {
    if(val!==undefined && val!=="") {
     this.fieldListFiltered=this.Feildproperty.filter(m=>m.fieldName.toLowerCase().includes(val.toLowerCase()));
     const index = this.ExtractDocument.indexOf(items);
      if (index >= 0) {
       this.ExtractDocument.find((item) => item.id == items.id).fieldName = val;
       this.ExtractDocument.find((item) => item.id == items.id).mapFields = false;
       this.ExtractDocument.find((item) => item.id == items.id).colorCode = "#cc570e";
      }
      this.CreateField=false;
      this.Finish=true;
    //  if(this.fieldListFiltered.length==0){
    //    this.CreateField=false;
    //    this.Finish=true;
    //  }

    //  var check=[];
    //  check = this.ExtractDocument.filter(x=>x.fieldID==0);
    //  if(check.length>0){
    //    this.CreateField=true;
    //    this.Finish=true;
    //  }
    }
    else{
      this.fieldListFiltered=[];
      this.fieldListFilteredAI=[];

      this.fieldListFiltered=this.Feildproperty.filter(m=>m.fieldName.toLowerCase().includes(val.toLowerCase()));
      const index = this.ExtractDocument.indexOf(items);
      if (index >= 0) {
       this.ExtractDocument.find((item) => item.id == items.id).fieldID =0;
       this.ExtractDocument.find((item) => item.id == items.id).fieldName = "";
       this.ExtractDocument.find((item) => item.id == items.id).mapFields = null;
       this.ExtractDocument.find((item) => item.id == items.id).colorCode = "";
      }

      var checkw=[];
      checkw = this.ExtractDocument.filter(x=>x.colorCode=="#cc570e");
      if(checkw.length>0){
        this.CreateField=false;
        this.Finish=true;
      }else{
        this.CreateField=true;
        this.Finish=false;
      }
      // if(this.fieldListFiltered.length==0){
      //   this.CreateField=false;
      //   this.Finish=true;
      // }
    }
  }

  fieldValueSelected(value:any,items:any){
    var check=[];
    check= this.ExtractDocument.filter(x=>x.fieldID==value.fieldID);
    if(check.length>0){
     // this.Finish=true;
      this.ExtractDocument.find((item) => item.id == items.id).fieldName = "";
      this.toastr.warning('Selected field allready mapped,Choose another field.', '', {
        timeOut: 3000,
      });

    var checkw=[];
    checkw = this.ExtractDocument.filter(x=>x.colorCode=="#cc570e");
    if(checkw.length>0){
      this.CreateField=false;
      this.Finish=true;
    }else{
      this.CreateField=true;
      this.Finish=false;
     }
     return;
    }
    const index = this.ExtractDocument.indexOf(items);
    if (index >= 0) {
      if(value.fieldID>0){
        this.ExtractDocument.find((item) => item.id == items.id).fieldID = value.fieldID;
        this.ExtractDocument.find((item) => item.id == items.id).fieldName = value.fieldName;
        this.ExtractDocument.find((item) => item.id == items.id).mapFields = false;
        this.ExtractDocument.find((item) => item.id == items.id).colorCode = "#47e309";       
      }      
    }
    var checkw=[];
    checkw = this.ExtractDocument.filter(x=>x.colorCode=="#cc570e");
    if(checkw.length>0){
      this.CreateField=false;
      this.Finish=true;
    }else{
      this.CreateField=true;
      this.Finish=false;
    }
    // var check=[];
    // check = this.ExtractDocument.filter(x=>x.mapFields==true);
    // if(check.length>0){
    //   this.CreateField=false;
    //   this.Finish=true;
    // }else{
    //   this.CreateField=true;
    //   this.Finish=false;
    // }
  }

  ItemValue(val,items:any) {
    const index = this.ExtractDocument.indexOf(items);
     if (index >= 0) {
       this.ExtractDocument.find((item) => item.id == items.id).value = val;      
     }  
    //  var check=[];
    //  check = this.ExtractDocument.filter(x=>x.mapFields==true);
    //  if(check.length>0){
    //    this.CreateField=false;
    //    this.Finish=true;
    //  }else{
    //    this.CreateField=true;
    //    this.Finish=false;
    //  }
  }

  createFields(){
    if(this.folderID==0){
      this.toastr.warning('Please select core record.', '', {
        timeOut: 3000,
      });
      return;
    }
    var check=[];
    var newFields=[];
    check= this.ExtractDocument.filter(x=>x.fieldName!=null || x.fieldID!=0);
    if(check.length>0){
      for (let i = 0; i < check.length; i++){
        var fieldName;
        if(check[i].fieldID>0){
         var data=[];
         data= this.Feildproperty.filter(x=>x.fieldID==check[i].fieldID);
         if(data.length>0){
          fieldName=data[0].fieldName;
         }
        }else{
          fieldName=check[i].fieldName;
        }
        var obj={
          keyID: check[i].keyID,
          keyName: check[i].key,
          fieldName: fieldName, //check[i].fieldName,
          fieldID: check[i].fieldID,
        }
        newFields.push(obj);
      }
    }   
   
    var reqModel={
      newFields: newFields,
      organizationID: Number(this.organizationId), 
      officeID: this.myOfficeID,
      userID: this.currentUser.UID,
      folderID: this.folderID,
    }
    //return;
    this.loaderService.showAILoader();
    this.settingsService.addFormKeyAsNewFields(reqModel).subscribe((response) => {
     if(response != undefined) {
        this.responseHolder = response;
        if(this.responseHolder.status == this.statusConst.statusSuccess) {          
          this.loaderService.hideAILoader();
          this.closeAiDetail(false);
          this.toastr.success('Field created successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hideAILoader();
          this.toastr.error('Field creation failed.', '', {
            timeOut: 3000,
          });
        }
      } else {
        this.loaderService.hideAILoader();
        this.toastr.error('Field creation failed.', '', {
          timeOut: 3000,
        });
      }
    });
  }


  finishFields() {    
    if(this.folderID==0 || Number(this.transactionID)==0){
      this.toastr.warning('Please select core record.', '', {
        timeOut: 3000,
      });
      return;
    }
    var reqModels={
      databaseID : Number(this.databaseId),
      organizationID : Number(this.organizationId),
      coreID : Number(this.transactionID),
      folderId : Number(this.folderID),
      subFolderID : Number(this.typeId),    
      userID: this.currentUser.UID,
      officeID:this.myOfficeID,
      officeIDList:this.OfficeIDList
    }    
    this.loaderService.showAILoader();
    this.coreService.getCoreUserDetails(reqModels).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        //this.loaderService.hideAILoader();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          var userDetails=[];
          userDetails = response.data.fields;
          this.Fieldcheck(userDetails);         
        } else {
          this.loaderService.hideAILoader();
        }
      }else{
        this.loaderService.hideAILoader();
      }
    });
  }

  Fieldcheck(userDetails){
    if(this.checkedAttachCore==true && this.transactionID>0){
      var check=[];
      var newFields=[];
      check= this.ExtractDocument.filter(x=>x.fieldID>0);
      if(check.length>0){
        for (let i = 0; i < check.length; i++){
          var fieldName;
          if(check[i].fieldID>0){
           var data=[];
           data= this.Feildproperty.filter(x=>x.fieldID==check[i].fieldID);
           if(data.length>0){
            fieldName=data[0].fieldName;
           }
          }else{
            fieldName=check[i].fieldName;
          }

          var record=[];
          record = userDetails.filter(x=>x.fieldID==check[i].fieldID)
          if(record.length>0){
            var obj={
              childFields: [],
              fieldNameID: null,
              fieldName: fieldName, 
              fieldID: check[i].fieldID,
              fieldValue: check[i].value,
              subFolderID: 0,
              id: record[0].id,
            }
            newFields.push(obj);
          }         
        }
      }  
     
     var reqModel={
      coreID: this.transactionID,
      fields: newFields,
      imageUrl: this.imageUrl,
      officeIDList: this.OfficeIDList,
      officeID: this.myOfficeID,
      databaseID : Number(this.databaseId),
      status:this.status,
      typeID: Number(this.typeId)>0?Number(this.typeId):0,
      userID : this.currentUser.UID,    
      organizationID : Number(this.organizationId)
     } 
     //return;
     this.loaderService.showAILoader();
     this.coreService.saveCoreUserDetails(reqModel).subscribe((response) => {
      if (response != undefined) {
         this.responseHolder = response;
          if(this.responseHolder.status == this.statusConst.statusSuccess) {            
             this.loaderService.hideAILoader(); 
             this.closeAiDetail(false);           
             this.toastr.success('Record update successfully.', '', {
               timeOut: 3000,
             });     
             if(this.toggleChangeCore==false){
              this._dataSharingService.sendUpdateDataUsingAIForCore(true);
              //this.router.navigate(['/core/documents'], {});
             }        
           }else{
             this.loaderService.hideAILoader();
           }
         }else{
           this.loaderService.hideAILoader();
         }
       });
    }


    // if(this.checkedAttachContact==true && this.transactionID>0){
    //   var check=[];
    //   var newFields=[];
    //   check= this.ExtractDocument.filter(x=>x.fieldID>0);
    //   if(check.length>0){
    //     for (let i = 0; i < check.length; i++){
    //       var fieldName;
    //       if(check[i].fieldID>0){
    //        var data=[];
    //        data= this.Feildproperty.filter(x=>x.fieldID==check[i].fieldID);
    //        if(data.length>0){
    //         fieldName=data[0].fieldName;
    //        }
    //       }else{
    //         fieldName=check[i].fieldName;
    //       }
    //       var obj1={
    //         childFields: [],
    //         fieldNameID: null,
    //         fieldName: fieldName, 
    //         fieldID: check[i].fieldID,
    //         fieldValue: check[i].value,
    //         subFolderID: 0,
    //         id: 0,
    //       }
    //       newFields.push(obj1);
    //     }
    //   }  
     
    //  var reqModelConatct={
    //   contactID: this.transactionID,
    //   fields: newFields,
    //   imageUrl: this.imageUrl,
    //   officeIDList: this.OfficeIDList,
    //   officeID: this.myOfficeID,
    //   databaseID : Number(this.databaseId),
    //   status:this.status,
    //   typeID: Number(this.typeId)>0?Number(this.typeId):0,
    //   userID : this.currentUser.UID,    
    //   organizationID : Number(this.organizationId)
    //  } 
    // // return;
    //  this.loaderService.showAILoader();
    //  this.coreService.saveContactUserDetails(reqModelConatct).subscribe((response) => {
    //   if (response != undefined) {
    //      this.responseHolder = response;
    //       if(this.responseHolder.status == this.statusConst.statusSuccess) {            
    //          this.loaderService.hideAILoader(); 
    //          this.closeAiDetail(false);           
    //          this.toastr.success('Record update successfully.', '', {
    //            timeOut: 3000,
    //          });             
    //        }else{
    //          this.loaderService.hideAILoader();
    //        }
    //      }else{
    //        this.loaderService.hideAILoader();
    //      }
    //    });
    // }

    // if(this.checkedAttachCompany==true && this.transactionID>0){
    //   var check=[];
    //   var newFields=[];
    //   check= this.ExtractDocument.filter(x=>x.fieldID>0);
    //   if(check.length>0){
    //     for (let i = 0; i < check.length; i++){
    //       var fieldName;
    //       if(check[i].fieldID>0){
    //        var data=[];
    //        data= this.Feildproperty.filter(x=>x.fieldID==check[i].fieldID);
    //        if(data.length>0){
    //         fieldName=data[0].fieldName;
    //        }
    //       }else{
    //         fieldName=check[i].fieldName;
    //       }
    //       var obj3={
    //         childFields: [],
    //         fieldNameID: null,
    //         fieldName: fieldName, 
    //         fieldID: check[i].fieldID,
    //         fieldValue: check[i].value,
    //         subFolderID: 0,
    //         id: 0,
    //       }
    //       newFields.push(obj3);
    //     }
    //   }  
     
    //  var reqModelCompany={
    //   companyID: this.transactionID,
    //   fields: newFields,
    //   imageUrl: this.imageUrl,
    //   officeIDList: this.OfficeIDList,
    //   officeID: this.myOfficeID,
    //   databaseID : Number(this.databaseId),
    //   status:this.status,
    //   typeID: Number(this.typeId)>0?Number(this.typeId):0,
    //   userID : this.currentUser.UID,    
    //   organizationID : Number(this.organizationId)
    //  } 
    // // return;
    //  this.loaderService.showAILoader();
    //  this.coreService.saveCompanyUserDetails(reqModelCompany).subscribe((response) => {
    //   if (response != undefined) {
    //      this.responseHolder = response;
    //       if(this.responseHolder.status == this.statusConst.statusSuccess) {            
    //          this.loaderService.hideAILoader(); 
    //          this.closeAiDetail(false);           
    //          this.toastr.success('Record update successfully.', '', {
    //            timeOut: 3000,
    //          });             
    //        }else{
    //          this.loaderService.hideAILoader();
    //        }
    //      }else{
    //        this.loaderService.hideAILoader();
    //      }
    //    });
    // }


  }

  timeout = null;  

  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;

  stateCtrSendlValue: any;
  showAddButton = false;

  ShowAttchedToCore: boolean = true;
  ShowAttchedToContact: boolean = false;
  ShowAttchedToCompany: boolean = false;

  checkedAttachCore: boolean = true;
  checkedAttachContact: boolean = false;
  checkedAttachCompany: boolean = false;

  attachedToSelectedCore: any = [] = [];
  attachedToSelectedContact: any = [] = [];
  attachedToSelectedCompany: any = [] = [];

  attachedToCoreList: any = [] = [];
  attachedToContactList: any = [] = [];
  attachedToCompanyList: any = [] = [];

  CorefolderID: number = 0;
  ContactfolderID: number = 0;
  CompanyfolderID: number = 0;
  roleIdList: any = [];

  selectedCoreId:number=0;
  selectedContactId:number=0;
  selectedCompanyId:number=0;

  
  selectCCC($event: MatRadioChange) {
    this.stateCtrl.reset();
    this.transactionID=0;
    this.Finish=false;         

    if ($event.value === 'Core') {
      this.ShowAttchedToCore = true;
      this.ShowAttchedToContact = false;
      this.ShowAttchedToCompany = false;

      this.checkedAttachCore = true;
      this.checkedAttachContact = false;
      this.checkedAttachCompany = false;     
      var SelectedCore = [];

      SelectedCore = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Core');
      if (SelectedCore.length > 0) {
       this.folderID = SelectedCore[0].folderID;
      }   
    }
    if ($event.value === 'Contact') {
      this.ShowAttchedToCore = false;
      this.ShowAttchedToContact = true;
      this.ShowAttchedToCompany = false;

      this.checkedAttachCore = false;
      this.checkedAttachContact = true;
      this.checkedAttachCompany = false;  
      
      var SelectedContact = [];

      SelectedContact = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Contact');
      if (SelectedContact.length > 0) {
      this.folderID = SelectedContact[0].folderID;
      }
    }
    if ($event.value === 'Company') {
      this.ShowAttchedToCore = false;
      this.ShowAttchedToContact = false;
      this.ShowAttchedToCompany = true;

      this.checkedAttachCore = false;
      this.checkedAttachContact = false;
      this.checkedAttachCompany = true;   
      
      var SelectedCompany = [];

      SelectedCompany = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Company');
      if (SelectedCompany.length > 0) {
       this.folderID = SelectedCompany[0].folderID;
      }
    }    
    this.attachedToSelectedCore=[];
    this.attachedToSelectedContact=[];
    this.attachedToSelectedCompany=[];
  }
  
//======================Core============================//

searchCore(val) {
  if (val.length >= 2) {
    this.attachedToCoreList = [];
    if (val != '') {
      this.searchName =val;
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.getsearchCore(val)
      }, 500);
    } else {
      this.attachedToCoreList = [];
    }
  }
}

getsearchCore(searchValue: any) {   
  var SelectedCCC = [];
  SelectedCCC = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Core');
  if (SelectedCCC.length > 0) {
    this.CorefolderID = SelectedCCC[0].folderID;
  }
  this.roleIdList = [];
  let roles = sessionStorage.getItem('roleIDList').split(',');
  roles.forEach(e => {
    this.roleIdList.push(Number(e));
  });

  var ReqModel = {
    roleIDList: this.roleIdList,
    searchKey: searchValue,
    userContactID: Number(sessionStorage.getItem('userContactID')),
    folderID: this.CorefolderID,
    databaseID: Number(this.databaseId),
    userID: this.currentUser.UID,
    officeID: this.myOfficeID,
    organizationID: Number(this.organizationId),
    officeIDList: this.OfficeIDList
  }
  this.settingsService.searchCore(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.attachedToCoreList = response.data;
        this.attachedToCoreList.push(
          {           
            "coreID":0,
            "name":"Create New",
            "email":"",
            "imageUrl":"",
            "isShared":this.isShare,
            "coreContactUserMapID":0,
            "trasactionalRoleIds":[],           
            "shortName":""
          }
        )
      } else {
        this.attachedToCoreList = [];
      }
    }
  })
}


attchedToCoreSelected(coreSelected: any) {
  if(coreSelected.coreID == 0) { 
    this.stateCtrl.reset();
    this.dialog.closeAll();
    this.transactionID=0;    
    this.addNew('Core');
    return;
   }

  var checkCore = [];
  this.stateCtrl.setValue('');
  checkCore = this.attachedToSelectedCore;
  if (checkCore.length == 0) {

    this.transactionID = coreSelected.coreID;
    this.imageUrl= coreSelected.imageUrl;
    this.status = coreSelected.status;
    this.typeId = coreSelected.typeID;

    this.name = coreSelected.name;
    this.email = coreSelected.email;

    this.selectedCoreId = coreSelected.coreID;

    var shortName = "";
    shortName = coreSelected.name.match(/\b(\w)/g).join('');
    var ReqModel = {
      coreID: coreSelected.coreID,
      email: coreSelected.email,
      name: coreSelected.name,        
      transactionID: coreSelected.transactionID,
      img: coreSelected.imageUrl,       
      shortName: shortName,
    }
    this.attachedToSelectedCore.unshift(ReqModel);
    this.stateCtrl.reset();
    if (this.attachedToSelectedCore.length > 0) {
      this.toggleChangeCore=false;
      this.ShowAttchedToCore=false;
      this.attachedToSelectedCore=[];

      var checkw=[];
      checkw = this.ExtractDocument.filter(x=>x.colorCode=="#cc570e");
      if(checkw.length>0){
        this.CreateField=false;
        this.Finish=true;
      }else{
        this.CreateField=true;
        this.Finish=false;
      }
     // this.showAddButton = true;
    } else {
     // this.showAddButton = false;
    }   
 }  
}


attchedToRemoveCore(item: any) {   
  const index = this.attachedToSelectedCore.indexOf(item);
  if (index >= 0) {
    this.attachedToSelectedCore.splice(index, 1);
  }
  if (this.attachedToSelectedCore.length == 0) {
    this.transactionID=0;
    this.stateCtrl.reset();
    this.showAddButton = false;
  }     
}



//======================Contact============================//

searchContacts(val) {
  if (val.length >= 2) {
    this.attachedToContactList = [];
    if (val != '') {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.getsearchContact(val)
      }, 500);
    } else {
      this.attachedToContactList = [];
    }
  }
}

getsearchContact(searchValue: any) {   
  var SelectedCCC = [];
  SelectedCCC = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Contact');
  if (SelectedCCC.length > 0) {
    this.ContactfolderID = SelectedCCC[0].folderID;
  }
  this.roleIdList = [];
  let roles = sessionStorage.getItem('roleIDList').split(',');
  roles.forEach(e => {
    this.roleIdList.push(Number(e));
  });

  var ReqModel = {
    roleIDList: this.roleIdList,
    searchKey: searchValue,
    userContactID: Number(sessionStorage.getItem('userContactID')),
    folderID: this.ContactfolderID,
    databaseID: Number(this.databaseId),
    userID: this.currentUser.UID,
    officeID: this.myOfficeID,
    organizationID: Number(this.organizationId),
    officeIDList: this.OfficeIDList
  }
  this.settingsService.searchContact(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.attachedToContactList = response.data;
      } else {
        this.attachedToContactList = [];
      }
    }
  })
}


attchedToContactSelected(contactSelected: any) {
  var checkContact = [];
  this.stateCtrl.setValue('');
  checkContact = this.attachedToSelectedContact;
  if (checkContact.length == 0) {

    this.transactionID = contactSelected.contactID;
    this.imageUrl= contactSelected.imageUrl;
    this.status = contactSelected.status;
    this.typeId = contactSelected.typeID;

    this.selectedContactId = contactSelected.contactID;
    var shortName = "";
    shortName = contactSelected.name.match(/\b(\w)/g).join('');
    var ReqModel = {
      contactID: contactSelected.contactID,
      email: contactSelected.email,
      name: contactSelected.name,      
      transactionID: contactSelected.transactionID,
      img: contactSelected.imageUrl,       
      shortName: shortName,
    }
    this.attachedToSelectedContact.unshift(ReqModel);
    this.stateCtrl.reset();
    if (this.attachedToSelectedContact.length > 0) {
      this.showAddButton = true;
    } else {
      this.showAddButton = false;
    }   
}  
}


attchedToRemoveContact(item: any) {
  const index = this.attachedToSelectedContact.indexOf(item);
  if (index >= 0) {
    this.attachedToSelectedContact.splice(index, 1);
  }
  if (this.attachedToSelectedContact.length == 0) {
    this.transactionID=0;
    this.stateCtrl.reset();
    this.showAddButton = false;
  }     
}





 //======================Company============================//

 searchCompany(val) {
  if (val.length >= 2) {
    this.attachedToCompanyList = [];
    if (val != '') {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.getsearchCompany(val)
      }, 500);
    } else {
      this.attachedToCompanyList = [];
    }
  }
}

getsearchCompany(searchValue: any) {   
  var SelectedCCC = [];
  SelectedCCC = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Company');
  if (SelectedCCC.length > 0) {
    this.CompanyfolderID = SelectedCCC[0].folderID;
  }

  this.roleIdList = [];

  let roles = sessionStorage.getItem('roleIDList').split(',');
  roles.forEach(e => {
    this.roleIdList.push(Number(e));
  });

  var ReqModel = {
    roleIDList: this.roleIdList,
    searchKey: searchValue,
    userContactID: Number(sessionStorage.getItem('userContactID')),
    folderID: this.CompanyfolderID,
    databaseID: Number(this.databaseId),
    userID: this.currentUser.UID,
    officeID: this.myOfficeID,
    organizationID: Number(this.organizationId),
    officeIDList: this.OfficeIDList
  }
  this.settingsService.searchCompany(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.attachedToCompanyList = response.data;
      } else {
        this.attachedToCompanyList = [];
      }
    }
  })
}


attchedToCompanySelected(companySelected: any) {
  var checkCompany = [];
  this.stateCtrl.setValue('');
  checkCompany = this.attachedToSelectedCompany;
  if (checkCompany.length == 0) {

    this.transactionID = companySelected.companyID;
    this.imageUrl= companySelected.imageUrl;
    this.status = companySelected.status;
    this.typeId = companySelected.typeID;

    this.selectedCompanyId = companySelected.companyID;
    var shortName = "";
    shortName = companySelected.name.match(/\b(\w)/g).join('');
    var ReqModel = {
      companyID: companySelected.companyID,
      email: companySelected.email,
      name: companySelected.name,       
      transactionID: companySelected.transactionID,
      img: companySelected.imageUrl,       
      shortName: shortName,
    }
    this.attachedToSelectedCompany.unshift(ReqModel);
    this.stateCtrl.reset();
    if (this.attachedToSelectedCompany.length > 0) {
      this.showAddButton = true;
    } else {
      this.showAddButton = false;
    }   
}  
}


attchedToRemoveCompany(item: any) {
  const index = this.attachedToSelectedCompany.indexOf(item);
  if (index >= 0) {
    this.attachedToSelectedCompany.splice(index, 1);
  }
  if (this.attachedToSelectedCompany.length == 0) {
    this.transactionID=0;
    this.stateCtrl.reset();
    this.showAddButton = false;
  }   
}

items:any;

openAI(item:any,templateRef: TemplateRef<any>){
  if(item.fieldName!="" || item.key.length>0){
    // var ReqModel = {
    //   searchKey: item.fieldName==""?item.key:item.fieldName,
    //   isSearch: false,
    //   isReturnSynonyms: true,
    //   userId: this.currentUser.UID,
    //   organizationID:  Number(this.organizationId),     
    //   officeID: this.myOfficeID,   
    //   }
    //   this.loaderService.showAILoader();
    //   this.settingsService.getSynonyms(ReqModel).subscribe(response => {
    //   if(response != undefined) {
    //      this.responseHolder = response;
    //      if (this.responseHolder.status == this.statusConst.statusSuccess) {
    //        if(response.data.synonymFields==null){
    //          this.Feildproperty = this.responseHolder.data.systemFields;
    //        }else{
    //          this.Feildproperty = this.responseHolder.data.synonymFields;
    //        }    
          
    //      this.filteredFeilds = this.feildsCtrl.valueChanges.pipe(startWith(''),
    //      map((feilds) =>
    //      feilds ? this.filterFeilds(feilds) : this.Feildproperty.slice()));
  
    //       // this.filteredFeildsAI = this.feildsCtrlAI.valueChanges.pipe(startWith(''),
    //       // map((feilds) =>
    //       //  feilds ? this.filterFeildsAI(feilds) : this.FeildpropertyAI.slice()));
   
    //       //  this.fieldListFiltered=this.FeildpropertyAI.filter(m=>m.fieldName.toLowerCase().includes(item.fieldName.toLowerCase()));
   
    //        this.loaderService.hideAILoader();
    //      }else{
    //        this.Feildproperty =[]; 
    //        this.loaderService.hideAILoader();         
    //      }
    //    }else{
    //      this.loaderService.hideAILoader();
    //      this.Feildproperty =[];
    //    }
    //  });
  
     const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'synoniumModal'
     });
     this.items=item;
     this.synonymFieldsAI=[];
     this.systemFieldsAI=[];
     this.getSynonymsWithAI(item.fieldName);
  }
 }


 synonymFieldsAI:any=[]=[];
 systemFieldsAI:any=[]=[];

getSynonymsWithAI(val) {
  var ReqModel = {
   searchKey: val,
   isSearch: false,
   isReturnSynonyms: true,
   userId: this.currentUser.UID,
   organizationID:  Number(this.organizationId),     
   officeID: this.myOfficeID,   
   }
   this.loaderService.showAILoader();
   this.settingsService.getSynonyms(ReqModel).subscribe(response => {
   if(response != undefined) {
      this.responseHolder = response;
      this.loaderService.hideAILoader();
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.synonymFieldsAI=this.responseHolder.data.synonymFields;
        this.systemFieldsAI=this.responseHolder.data.systemFields;
        if(this.synonymFieldsAI==null){
          this.synonymFieldsAI=[];
        }
        if(this.systemFieldsAI==null){
          this.systemFieldsAI=[];
        }
        // if(response.data.synonymFields==null){
        //   this.FeildpropertyAI = this.responseHolder.data.systemFields;
        // }else{
        //   this.FeildpropertyAI = this.responseHolder.data.synonymFields;
        // }    
       
      //  this.filteredFeildsAI = this.feildsCtrlAI.valueChanges.pipe(startWith(''),
      //  map((feilds) =>
      //   feilds ? this.filterFeildsAI(feilds) : this.FeildpropertyAI.slice()));

      //   this.fieldListFilteredAI=this.FeildpropertyAI.filter(m=>m.fieldName.toLowerCase().includes(val.toLowerCase()));

       // this.loaderService.hideAILoader();
      }else{
        this.synonymFieldsAI=[];
        this.systemFieldsAI=[];
        //this.FeildpropertyAI =[]; 
        this.loaderService.hideAILoader();         
      }
    }else{     
     // this.FeildpropertyAI =[];
     this.synonymFieldsAI=[];
     this.systemFieldsAI=[];
     this.loaderService.hideAILoader();
    }
  });
} 

searchFieldsAI(val) {
  if(val!==undefined && val!=="") {
   // this.getSynonymsWithAI(val);
  //  this.fieldListFilteredAI=this.FeildpropertyAI.filter(m=>m.fieldName.toLowerCase().includes(val.toLowerCase()));
  //  const index = this.ExtractDocument.indexOf(this.items);
  //   if (index >= 0) {
  //    this.ExtractDocument.find((item) => item.id == this.items.id).fieldName = val;      
  //   }
  
  //  if(this.fieldListFilteredAI.length==0){
  //    this.CreateField=false;
  //    this.Finish=true;
  //  }  
  // }
  // else{
  //   this.fieldListFiltered=[];
  //   this.fieldListFilteredAI=[];
  // }
  }
}

fieldValueSelectedAI(value:any){
  var check=[];
  check= this.ExtractDocument.filter(x=>x.fieldID==value.fieldID);
  if(check.length>0){
    this.Finish=true;
    this.toastr.warning('Selected field allready mapped,Choose another field.', '', {
      timeOut: 3000,
    });
    return;
  }
  const index = this.ExtractDocument.indexOf(this.items);
  if (index >= 0) {
    if(value.fieldID>0){
      this.ExtractDocument.find((item) => item.id == this.items.id).fieldID = value.fieldID;
      this.ExtractDocument.find((item) => item.id == this.items.id).fieldName = value.fieldName;
      this.ExtractDocument.find((item) => item.id == this.items.id).mapFields = false;
      this.ExtractDocument.find((item) => item.id == this.items.id).colorCode = "#47e309";            
    }      
  }

   var checkw=[];
   checkw = this.ExtractDocument.filter(x=>x.colorCode=="#cc570e");
   if(checkw.length>0){
     this.CreateField=false;
     this.Finish=true;
    }else{
     this.CreateField=true;
     this.Finish=false;
    }

  // var check=[];
  // check = this.ExtractDocument.filter(x=>x.mapFields==true);
  // if(check.length>0){
  //   this.CreateField=false;
  //   this.Finish=true;
  // }else{
  //   this.CreateField=true;
  //   this.Finish=false;
  // }
  this.closeAI();
}

closeAI(){
  this.synonymFieldsAI=[];
  this.systemFieldsAI=[];
  this.items=[];
 // this.fieldListFilteredAI=[];
  //this.feildsCtrlAI.reset();
  this.dialog.closeAll();
}


AutoFilled(items:any){

  if(items!=="") {
    var check=[];
    check= this.Feildproperty.filter(x=>x.fieldName.toLowerCase()==items.key.toLowerCase());
    if(check.length>0){
      this.ExtractDocument.find((item) => item.id == items.id).fieldID = check[0].fieldID;
      this.ExtractDocument.find((item) => item.id == items.id).fieldName = check[0].fieldName;
      this.ExtractDocument.find((item) => item.id == items.id).mapFields = false;
      this.ExtractDocument.find((item) => item.id == items.id).colorCode = "#47e309"; 

      var checkw=[];
      checkw = this.ExtractDocument.filter(x=>x.colorCode=="#cc570e");
      if(checkw.length>0){
        this.CreateField=false;
        this.Finish=true;
      }else{
        this.CreateField=true;
        this.Finish=false;
      }

    }else{
      this.ExtractDocument.find((item) => item.id == items.id).fieldName = items.key;
      this.ExtractDocument.find((item) => item.id == items.id).mapFields = false;
      this.ExtractDocument.find((item) => item.id == items.id).colorCode = "#cc570e";

      this.CreateField=false;
      this.Finish=true;
    }  
   }   
 }


 showAddCore:boolean = false;
 searchName:string="";
 isShare: boolean = false;
 Module:string="";

 addNew(module){
  this.mainModuleName="Core";
  var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
  var Module = menuModulesList.filter((x:any) => x.mainModuleName == 'Core');
  var Modulename= Module[0].orgModuleName;
  this.Module = Modulename;
  this.showAddCore = !this.showAddCore;
}

 getClose(message){
  this.showAddCore = message;
}


getselectedTransactionId(result) {
  this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
  var SelectedCore = [];       
  SelectedCore = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Core');
   if (SelectedCore.length > 0) {
     this.CoreShowName = SelectedCore[0].orgModuleName;
     this.folderID =SelectedCore[0].folderID;
    }
    
    this.transactionID = result.transactionId; 
    this.imageUrl= result.imageUrl;
    this.status = result.status;
    this.typeId = result.typeID;

    this.name = result.name;
    this.email = result.email;

    this.selectedCoreId = this.transactionID;

    var shortName = "";
    shortName = result.name.match(/\b(\w)/g).join('');
    var ReqModel = {
      coreID: this.transactionID,
      email: result.email,
      name: result.name,        
      transactionID: "",
      img: result.imageUrl,       
      shortName: shortName,
    }
    this.attachedToSelectedCore.unshift(ReqModel);
    
    if (this.attachedToSelectedCore.length > 0) {
      this.toggleChangeCore=false;
      this.ShowAttchedToCore=false;
      this.attachedToSelectedCore=[];

      var checkw=[];
      checkw = this.ExtractDocument.filter(x=>x.colorCode=="#cc570e");
      if(checkw.length>0){
        this.CreateField=false;
        this.Finish=true;
      }else{
        this.CreateField=true;
        this.Finish=false;
      }
     } else {
     
    }   
}

}
